import type { Theme } from '@emotion/react';
import styled from '@emotion/styled';

import type { DotsColor, DotsSize } from './types';

function getColor(theme: Theme, color: DotsColor): string {
  const colors: Record<DotsColor, string> = {
    grey: theme.colors.background.overlay,
    blue: theme.colors.info.solid,
    green: theme.colors.brand.solid,
    orange: theme.colors.warning.solid,
    red: theme.colors.error.solid,
    purple: theme.colors.accent.solid,
  };

  return colors[color];
}

const SIZE_CONFIG: Record<DotsSize, number> = {
  xs: 6,
  sm: 8,
  md: 10,
  lg: 12,
};

const TRANSIENT_PROPS = new Set(['$color', '$size']);

export const StyledDots = styled('span', {
  shouldForwardProp: (prop) => !TRANSIENT_PROPS.has(prop),
})<{
  $color: DotsColor;
  $size: DotsSize;
}>(({ theme, $color, $size }) => {
  const dimension = SIZE_CONFIG[$size];

  return {
    display: 'inline-block',
    width: dimension,
    height: dimension,
    flexShrink: 0,
    borderRadius: theme.radius.full,
    backgroundColor: getColor(theme, $color),
    boxSizing: 'border-box',
  };
});
